<template>
  <div id="welcome-content" :class="{ animate: animate }">
    <div class="input-avatar-container">
      <LoginOverlayAvatar class="avatar" />
      <div class="input-container">
        <input
          ref="usernameInput"
          name="name"
          type="text"
          placeholder="Enter your name"
          autofocus
          autocomplete="off"
          @input="onInput"
          @keyup.enter="onLogin"
        />
        <div :class="{ hide: hideWarning }">
          Congratulations on reaching the character limit!
        </div>
      </div>
    </div>
    <button class="button-start" :disabled="disableButton" @click="onLogin">
      start
    </button>
  </div>
</template>

<script>
import LoginOverlayAvatar from "./LoginOverlayAvatar";

export default {
  name: "LoginOverlayContent",
  components: {
    LoginOverlayAvatar,
  },
  data() {
    return {
      animate: false,
      hideWarning: true,
      disableButton: true,
    };
  },
  methods: {
    onLogin() {
      this.$emit("login", this.$refs.usernameInput.value);
    },
    onInput(e) {
      this.disableButton = e.target.value.length <= 0;
      this.hideWarning = e.target.value.length <= 9;
      e.target.value = e.target.value.substring(0, 9);
    },
  },
  mounted() {
    if (document.hidden) {
      // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden) {
          setTimeout(() => {
            this.animate = true;
          }, 300);
        }
      });
    } else {
      setTimeout(() => {
        this.animate = true;
      }, 300);
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables";

#welcome-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  opacity: 0;

  transition-property: opacity;
  transition-duration: 1.25s;
  transition-timing-function: ease-in-out;

  &.animate {
    opacity: 1;
  }

  .input-avatar-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .input-container {
      margin-left: 20px;
      max-width: 280px;

      input {
        width: 100%;
        background: none;
        border: none;
        font-size: 2.2em;
        text-align: left;
        border-bottom-width: 1px;
        border-bottom-color: black;
        border-bottom-style: solid;
        outline: none;
      }

      div {
        color: $warning-text;

        margin-top: 8px;
        &.hide {
          visibility: hidden;
        }
      }
    }
  }

  .button-start {
    background-color: rgb(97, 189, 126);
    border: none;
    padding: 0px;
    margin-top: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: 1.8em;
    font-weight: bold;
    color: $primary-text-white;
    cursor: pointer;

    &:disabled {
      background-color: grey;
    }
  }
}
</style>
